import type { TChatConfig } from '@wealthlane/chatbot';

const chatbotResponseProtocol = (
  process.env.REACT_APP_CHATBOT_RESPONSE_PROTOCOL || 'api'
) as 'api' | 'websocket';

export const chatbotRestBaseUrl = (
  process.env.REACT_APP_CHATBOT_REST_URL ||
  process.env.REACT_APP_INGESTION_ENDPOINT ||
  ''
).replace(/\/$/, '');

export const chatbotHttpUrl =
  process.env.REACT_APP_CHATBOT_SSE_URL ||
  (chatbotRestBaseUrl ? `${chatbotRestBaseUrl}/chat/stream` : '');

export const configState: TChatConfig = {
  responseProtocol: "api" as const as "api" | "websocket", // change this to chatbotResponseProtocol
  responseType: 'stream',
  endpoint: process.env.REACT_APP_CHATBOT_WEBSOCKET_API,
  httpEndpoint: chatbotHttpUrl,
  timeout: 30000,
  ingestionEndpoint: chatbotRestBaseUrl || process.env.REACT_APP_INGESTION_ENDPOINT,
  disclaimer: 'For assistance, please contact your dedicated specialist.',
};

export const devLogger = {
  debug: () => { },
  info: () => { },
  warn: () => { },
  error: console.error,
};
